var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_c('v-btn',{attrs:{"href":_vm.fileUrl,"target":"blank","depressed":"","small":"","color":"accent"}},[_vm._v(" Visualizar Termo ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }